import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { ImporterRun } from 'dashboard/models/importer-run';
import { saveImporterRun } from 'dashboard/redux/actions/importer-runs';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

export const cancelImporterRun = (importerRunId: string) => {
  return async (dispatch: Dispatch) => {
    const response = await SessionClientDashboard.postResourceAction<ImporterRun>(
      {
        type: ApiModel.ImporterRun,
        id: importerRunId,
      },
      'cancel',
      {},
    );
    dispatch(saveImporterRun(response.data));
    return response;
  };
};

export const loadImporterRun = (importerRunId: string) => {
  return async (dispatch: Dispatch) => {
    const response = await SessionClientDashboard.getResource<ImporterRun>(
      ApiEndpoint.ImporterRun,
      importerRunId,
    );
    dispatch(saveImporterRun(response.data));
  };
};

export const downloadCsv = (importerRunId: string) => {
  return async () => {
    const response = await SessionClientDashboard.getResource(
      ApiEndpoint.ImporterRun,
      importerRunId,
    );
    return response;
  };
};
